// extracted by mini-css-extract-plugin
module.exports = {"Spacer":"Spacer_Spacer__d0WW8","inner":"Spacer_inner__i9jNd","line":"Spacer_line___Q3Og"};